<template>
    <slot :signIn="signIn" :showVideo="showVideo"></slot>
    <Teleport to="#portal-target-2">
        <modals-container></modals-container>
    </Teleport>
</template>
<script>

import { ModalsContainer } from 'vue-final-modal'
import modalManager from '../modules/modalManager'

export default {
    name: 'KBMax',
    components: [],
    props:{
        params: {
            default:{},
            type:Object
        }
    },
    data() {
        return {
            
        }
    },
    methods: {
        signIn(){
            modalManager.showSignIn(this.params);
        },
        showVideo(youtube){
            console.warn("We can't show videos.");
        }
    },
    mounted(){
        //handle the kbmax-embed.js event that should open the configured sign in modal
        window.addEventListener('open-sign-in-modal', this.signIn);
    },
    unmounted(){
        window.removeEventListener('open-sign-in-modal', this.signIn)
    }
}
</script>